var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.655,
    height: 80.148,
    viewBox: "0 0 165.655 80.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_ID-Auto",
    "data-name": "Logo ID-Auto",
    transform: "translate(-37.13 -24.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(0 3.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M190.591,105.478H49.314A12.2,12.2,0,0,1,37.13,93.294V37.514A12.2,12.2,0,0,1,49.314,25.33H190.6a12.2,12.2,0,0,1,12.184,12.184V93.3A12.2,12.2,0,0,1,190.591,105.478ZM49.314,29.176A8.336,8.336,0,0,0,40.986,37.5v55.79a8.336,8.336,0,0,0,8.328,8.328H190.6a8.336,8.336,0,0,0,8.328-8.328V37.514a8.336,8.336,0,0,0-8.328-8.328H49.314Z",
    transform: "translate(0 -4.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(0.379 -0.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M189.347,99.062H49.868a6.3,6.3,0,0,1-6.3-6.3V38.018a6.3,6.3,0,0,1,6.3-6.3H189.337a6.3,6.3,0,0,1,6.3,6.3V92.764A6.3,6.3,0,0,1,189.347,99.062ZM49.868,32.208a5.829,5.829,0,0,0-5.819,5.819V92.774a5.829,5.829,0,0,0,5.819,5.819H189.337a5.829,5.829,0,0,0,5.819-5.819V38.018a5.829,5.829,0,0,0-5.819-5.819H49.868Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(2.778 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(-8.686 -0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M191.18,57.55V75a5.436,5.436,0,0,1-1.47,4.034,4.135,4.135,0,0,1-3,1.24h-6.514a4.308,4.308,0,0,1-3.666-1.767,6.448,6.448,0,0,1-1.194-3.978V57.8a5.913,5.913,0,0,1,1.6-4.58,5.182,5.182,0,0,1,3.639-1.231h4.98a5.586,5.586,0,0,1,3.721.944C189.259,52.943,191.152,54.053,191.18,57.55Zm-4.254.028V56.19c0-.426-.276-.629-.818-.629h-5.642a.829.829,0,0,0-.643.241.782.782,0,0,0-.239.555V75.009a.7.7,0,0,0,.285.648,1.313,1.313,0,0,0,.689.176h5.513c.542,0,.818-.2.818-.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(-3.063 -0.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M82.921,52a7.141,7.141,0,0,1,4.231,1.066,2.272,2.272,0,0,1,1.108,1.783.989.989,0,0,1-.191.689l-2.541,2.473a.488.488,0,0,1-.573.028.519.519,0,0,1-.372-.506V56.155c0-.423-.287-.625-.85-.625H77.64a.884.884,0,0,0-.669.239.761.761,0,0,0-.248.552V74.854a.68.68,0,0,0,.3.644,1.414,1.414,0,0,0,.716.175h5.731c.564,0,.85-.2.85-.6V61.34a.4.4,0,0,1,.048-.2.383.383,0,0,1,.086-.11c1.452-1.25,2.407-2.087,2.846-2.491s.85-.8,1.223-1.177c.019-.018.067-.018.143.018a.145.145,0,0,1,.115.138V74.854a5.267,5.267,0,0,1-1.528,4.008,4.4,4.4,0,0,1-3.123,1.232H71.154a3.05,3.05,0,0,1-.65-.064c-.22-.046-.325-.156-.325-.349V76.407a6.129,6.129,0,0,1,1.4-.781c.458-.23.688-.441.688-.625V56.716c0-.23-.325-.5-.965-.791s-.965-.506-.965-.625V52.34a.276.276,0,0,1,.21-.248A1.131,1.131,0,0,1,71.03,52H82.921Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(-3 -0.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M66.761,80.082c0,.167-.1.251-.316.251H53.821c-.251,0-.381-.14-.381-.409V76.408a.249.249,0,0,1,.223-.251l4.279-.856a.537.537,0,0,0,.223-.288V57.171c0-.149-.009-.3-.019-.456a.645.645,0,0,0-.335-.456c-.316-.233-.642-.474-.967-.726s-.493-.484-.493-.7V52.873a.847.847,0,0,1,.177-.5.7.7,0,0,1,.623-.251H63.4c.447,0,.67.2.67.6V55c0,.167-.177.372-.54.6a9.844,9.844,0,0,0-1.079.716c-.1.093-.158.381-.158.874V75.32c0,.13.074.186.223.186l3.935.567c.214,0,.316.074.316.223v3.786Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(-6.658 -0.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M127.055,79.733q.07.471-.447.471h-3.532a.592.592,0,0,1-.634-.471L121.3,74.574h-8.807l-1.146,5.159a.614.614,0,0,1-.671.471h-3.495a.444.444,0,0,1-.335-.157.369.369,0,0,1-.112-.314l6.1-27.162a.592.592,0,0,1,.634-.471H120.3a.563.563,0,0,1,.634.471Zm-7.53-8.971a1.117,1.117,0,0,0,.652-.111.449.449,0,0,0,.112-.332,3.747,3.747,0,0,1-.028-.378l-2.926-13.133a.25.25,0,0,0-.158-.222c-.084-.018-.168-.046-.252-.065a1.78,1.78,0,0,0-.289.028c-.112.018-.168.1-.186.249l-2.889,13.133c-.084.351-.056.572.093.655a.935.935,0,0,0,.634.157h5.237Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(-6.424 -0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M169.754,56.4c0,.148-.062.222-.177.222h-6c-.239,0-.362.083-.362.25v23.09c0,.213-.115.315-.336.315h-3.649q-.239,0-.239-.222V57.091q0-.472-.424-.472h-5.548c-.141,0-.212-.1-.212-.315V52.485a.435.435,0,0,1,.15-.25.419.419,0,0,0,.062-.065h16.45c.177,0,.274.1.274.315V56.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(-7 -1.051)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(97.64 64.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M122.61,71.25",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    transform: "translate(-5.253 -0.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(131.21 52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M142.875,80.283h-6.19a5.478,5.478,0,0,1-5.474-5.474V52h4.368V74.809a1.1,1.1,0,0,0,1.106,1.106h6.19a1.1,1.1,0,0,0,1.106-1.106V52h4.368V74.809A5.484,5.484,0,0,1,142.875,80.283Z",
    transform: "translate(-131.21 -52)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a1f3dee185255c2b741f5b18eb1ea5d3.svg";
export { ForwardRef as ReactComponent };